import { render, staticRenderFns } from "./CustomerWallet.vue?vue&type=template&id=5d9522b0"
import script from "./CustomerWallet.vue?vue&type=script&lang=js"
export * from "./CustomerWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports